export const CATEGORIES_ACTION_TYPES={
    SET_CATEGORIES:'SET_CATEGORIES_MAP',
    FETCH_CATEGORIES_START:'FETCH_CATEGORIES_START',
    FETCH_CATEGORIES_SUCCESS:'FETCH_CATEGORIES_SUCCESS',
    FETCH_CATEGORIES_FAILED:'FETCH_CATEGORIES_FAILED',
}